import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "orderInput"]

  connect() {
    this.draggedItem = null
    this.boundPointerMove = this.pointerMove.bind(this)
    this.boundPointerEnd = this.pointerEnd.bind(this)
    this.refresh()
  }

  disconnect() {
    this.removePointerListeners()
  }

  pointerStart(event) {
    if (event.button !== undefined && event.button !== 0) return
    if (event.target.closest("a, button, input, textarea, select, label")) return

    this.draggedItem = event.currentTarget
    this.draggedItem.classList.add("is-dragging")
    this.draggedItem.setPointerCapture?.(event.pointerId)

    window.addEventListener("pointermove", this.boundPointerMove)
    window.addEventListener("pointerup", this.boundPointerEnd)
    window.addEventListener("pointercancel", this.boundPointerEnd)
    event.preventDefault()
  }

  pointerMove(event) {
    if (!this.draggedItem) return

    const target = document
      .elementFromPoint(event.clientX, event.clientY)
      ?.closest("[data-admin-image-sort-target='item']")

    if (!target || target === this.draggedItem || !this.element.contains(target)) return

    const targetBox = target.getBoundingClientRect()
    const shouldInsertAfter = event.clientX > targetBox.left + targetBox.width / 2

    if (shouldInsertAfter) {
      target.after(this.draggedItem)
    } else {
      target.before(this.draggedItem)
    }

    this.refresh()
    event.preventDefault()
  }

  pointerEnd() {
    if (this.draggedItem) this.draggedItem.classList.remove("is-dragging")
    this.draggedItem = null
    this.removePointerListeners()
    this.refresh()
  }

  dragStart(event) {
    this.draggedItem = event.currentTarget
    event.currentTarget.classList.add("is-dragging")
    event.dataTransfer.effectAllowed = "move"
  }

  dragOver(event) {
    event.preventDefault()

    const target = event.currentTarget
    if (!this.draggedItem || target === this.draggedItem) return

    const targetBox = target.getBoundingClientRect()
    const shouldInsertAfter = event.clientX > targetBox.left + targetBox.width / 2

    if (shouldInsertAfter) {
      target.after(this.draggedItem)
    } else {
      target.before(this.draggedItem)
    }

    this.refresh()
  }

  drop(event) {
    event.preventDefault()
    this.refresh()
  }

  dragEnd() {
    if (this.draggedItem) this.draggedItem.classList.remove("is-dragging")
    this.draggedItem = null
    this.refresh()
  }

  moveEarlier(event) {
    const item = event.currentTarget.closest("[data-admin-image-sort-target='item']")
    const previous = item?.previousElementSibling
    if (!item || !previous) return

    previous.before(item)
    this.refresh()
  }

  moveLater(event) {
    const item = event.currentTarget.closest("[data-admin-image-sort-target='item']")
    const next = item?.nextElementSibling
    if (!item || !next) return

    next.after(item)
    this.refresh()
  }

  refresh() {
    this.itemTargets.forEach((item, index) => {
      const input = item.querySelector("[data-admin-image-sort-target='orderInput']")
      const meta = item.querySelector(".admin-image-grid__meta")
      const earlierButton = item.querySelector("[data-action='admin-image-sort#moveEarlier']")
      const laterButton = item.querySelector("[data-action='admin-image-sort#moveLater']")

      if (input) input.value = item.dataset.imageId
      if (meta) meta.textContent = `${index + 1}枚目`
      if (earlierButton) earlierButton.disabled = index === 0
      if (laterButton) laterButton.disabled = index === this.itemTargets.length - 1
    })
  }

  removePointerListeners() {
    window.removeEventListener("pointermove", this.boundPointerMove)
    window.removeEventListener("pointerup", this.boundPointerEnd)
    window.removeEventListener("pointercancel", this.boundPointerEnd)
  }
}
